module.exports = __webpack_public_path__ + "static/media/chair-booked-small.e08b676f.png";